var INVERT_POLARITY_LANGUAGE_CODES = ["ja-JP", "ko-KR", "zh-CN", "zh-TW"];

export { INVERT_POLARITY_LANGUAGE_CODES };
